// @ts-nocheck
// TODO: tighten types after migration
import React from "react";

export default function SocialLinks({ className = "", noShadow = false }) {
    // Social media links from footer.js

    const instagram_link = () => {
        window.location.href = "https://instagram.com/im_harivishnu";
    };

    const twitter_link = () => {
        window.location.href = "https://twitter.com/Im_Harivishnu";
    };


    const threads_link = () => {
        window.location.href = "https://www.threads.com/@im_harivishnu";
    };

    const youtube_link = () => {
        window.location.href = "https://www.youtube.com/@im_harivishnu";
    };

    const github_link = () => {
        window.location.href = "https://github.com/Im-harivishnu";
    };

    const linkedin_link = () => {
        window.location.href = "https://www.linkedin.com/in/harivishnu-s/";
    };

    const scholar_link = () => {
        window.location.href = "https://scholar.google.com/citations?hl=en&user=4mOxTrAAAAAJ";
    };

    const orcid_link = () => {
        window.location.href = "https://orcid.org/0009-0009-4657-0766";
    };

    const iconClass = `w-[27px] h-[27px] rounded-[6px] flex items-center justify-center cursor-pointer transition-all duration-300 border border-[#777777] relative hover:translate-y-[-1px] ${noShadow ? "" : "shadow-[-1px_1px_#47b5ff] hover:shadow-[-2px_2px_#47b5ff]"}`;

    return (
        <div className={`grid grid-cols-5 gap-[10px] justify-items-start w-full my-5 transition-all duration-300 md:flex md:flex-row md:items-center md:justify-start ${className}`}>
            <div className={iconClass} onClick={youtube_link}>
                <i className="fi fi-brands-youtube text-[20px] text-[var(--text-color)] flex items-center justify-center w-full h-full leading-none transition-all duration-300 hover:text-[#FF0000] hover:text-[24px]"></i>
            </div>
            <div className={iconClass} onClick={instagram_link}>
                <i className="fi fi-brands-instagram text-[20px] text-[var(--text-color)] flex items-center justify-center w-full h-full leading-none transition-all duration-300 hover:text-[#E4405F] hover:text-[24px]"></i>
            </div>
            <div className={`${iconClass} hover:border-[#000000]`} onClick={threads_link}>
                <i className="bi bi-threads text-[20px] text-[var(--text-color)] flex items-center justify-center w-full h-full leading-none transition-all duration-300 hover:text-[#000000] hover:text-[24px]"></i>
            </div>
            <div className={iconClass} onClick={linkedin_link}>
                <i className="fi fi-brands-linkedin text-[20px] text-[var(--text-color)] flex items-center justify-center w-full h-full leading-none transition-all duration-300 hover:text-[#0077b5] hover:text-[24px]"></i>
            </div>
            <div className={iconClass} onClick={twitter_link}>
                <i className="fi fi-brands-twitter-alt text-[20px] text-[var(--text-color)] flex items-center justify-center w-full h-full leading-none transition-all duration-300 hover:text-[#1da1f2] hover:text-[24px]"></i>
            </div>
            <div className={iconClass} onClick={github_link}>
                <i className="fi fi-brands-github text-[20px] text-[var(--text-color)] flex items-center justify-center w-full h-full leading-none transition-all duration-300 hover:text-[#333333] hover:text-[24px]"></i>
            </div>
            <div className={iconClass} onClick={scholar_link}>
                <i className="fa-brands fa-google-scholar text-[20px] text-[var(--text-color)] flex items-center justify-center w-full h-full leading-none transition-all duration-300 hover:text-[#4285F4] hover:text-[24px]"></i>
            </div>
            <div className={iconClass} onClick={orcid_link}>
                <i className="fa-brands fa-orcid text-[20px] text-[var(--text-color)] flex items-center justify-center w-full h-full leading-none transition-all duration-300 hover:text-[#A6CE39] hover:text-[24px]"></i>
            </div>
        </div>
    );
}
